import {Exclude, Type} from 'class-transformer';
import {IdCodeNameModel} from 'common-shared';
import { ExpressionModel } from '../../common/expression.model';
import {PropertyMappingModel} from "../../properties/models/property-mapping.model";
import {SpecLineModel} from "../../properties/models/spec-line.model";

export enum InstructionType {
  Use,
  Input,
  Output
}

export class MasterInstructionModel extends IdCodeNameModel{
  Type: InstructionType;
  ParentId?: string;
  SourceCode?: string;
  ParentSourceCode?: string;
}

export class MasterInputInstructionModel extends MasterInstructionModel {
  ItemId?: string;
  ParentItemId?: string;
  ItemGroupId?: string;
  ParentItemGroupId?: string;
  SetupRatio: ExpressionModel = new ExpressionModel();
  ProductionRatio: ExpressionModel = new ExpressionModel();
  TeardownRatio: ExpressionModel = new ExpressionModel();
  TimeConstraintMethodClv?: string;
  MasterOperationId: string;
  ValidCondition: ExpressionModel = new ExpressionModel();
  TaskSelectorId?: string;
  ItemType: string;
  Sequence?: number;
  @Exclude({ toPlainOnly: true })
  $InheritedOperationPropertyMappings: PropertyMappingModel[];
  @Type(() => PropertyMappingModel)
  OperationItemProperties: PropertyMappingModel[]  = [];
  ParentValidCondition: string;
  ParentProductionRatio: string;
  @Type(() => Date)
  ValidFrom?: Date;
  @Type(() => Date)
  ValidTo?: Date;
  TimeConstraintMin: ExpressionModel = new ExpressionModel();
  TimeConstraintMax: ExpressionModel = new ExpressionModel();
  YieldRate?: number;
  PreviousProcessNumber?; number;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  IsPhantom: boolean;

  constructor(init?: Partial<MasterInputInstructionModel>) {
    super();
    Object.assign(this, init);
    this.Type = InstructionType.Input;
  }
}

export class MasterOutputInstructionModel extends MasterInstructionModel {
  ItemId?: string;
  ItemGroupId?: string;
  SetupRatio: ExpressionModel = new ExpressionModel();
  ProductionRatio: ExpressionModel = new ExpressionModel();
  TeardownRatio: ExpressionModel = new ExpressionModel();
  ParentProductionRatio: string;
  MasterOperationId: string;
  ValidCondition: ExpressionModel = new ExpressionModel();
  TaskSelectorId?: string;
  Sequence?: number;
  @Exclude({ toPlainOnly: true })
  $InheritedOperationPropertyMappings: PropertyMappingModel[];
  @Type(() => PropertyMappingModel)
  OperationItemProperties: PropertyMappingModel[]  = [];
  @Type(() => Date)
  ValidFrom?: Date;
  @Type(() => Date)
  ValidTo?: Date;
  YieldRate?: number;
  PreviousProcessNumber?; number;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];

  constructor() {
    super();
    this.Type = InstructionType.Output;
  }
}
